// eslint-disable-next-line import/prefer-default-export
export class HttpError extends Error {
  constructor(err, status = 500, detail = null, data = null, response = null) {
    super(err);

    // View-name (relevant in Sentry reports)
    this.name = 'HttpError';

    this.status = status;
    this.detail = detail;
    this.data = data;
    this.response = response;
  }
}

/**
 * @return {boolean}
 * */
export const isHttpError = (error) => !!error.data && !!error.data.status;
